export default {
  state: {
    hasAccess:
      document.getElementById('hasEditAccess') &&
      document.getElementById('hasEditAccess').value === 'true',
    hasCreate:
      document.getElementById('hasCreateAccess') &&
      document.getElementById('hasCreateAccess').value === 'true',
    userAvatar:
      document.getElementById('userAvatar') && document.getElementById('userAvatar').value,
    userAlias: document.getElementById('userAlias') && document.getElementById('userAlias').value,
    projectUuid: document.querySelector('meta[name="projectUuid"]')?.content,
    locale: localStorage.getItem('locale') || '',
    defaultBranch: document.querySelector('meta[name="defaultBranch"]'),
    featureModel: {},
    applicationVersion: 'cloudweb',
    colorScheme:
      window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
  },
  mutations: {
    setFeatureModel(state, payload) {
      state.featureModel = payload;
    },
    setColorScheme(state, payload) {
      if (payload === 'auto') {
        state.colorScheme =
          window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light';
      } else state.colorScheme = payload;
    }
  },
  actions: {
    setFeatureModel(state, payload) {
      state.commit('setFeatureModel', payload);
    },
    setColorScheme(state, payload) {
      state.commit('setColorScheme', payload);
    }
  },
  getters: {
    getHasAccess(state) {
      return state.hasAccess;
    },
    getHasCreate(state) {
      return state.hasCreate;
    },
    getUserAvatar(state) {
      return state.userAvatar;
    },
    getUserAlias(state) {
      return state.userAlias;
    },
    getLocale(state) {
      return state.locale;
    },
    getFeatureModel(state) {
      return state.featureModel;
    },
    getApplicationVersion(state) {
      return state.applicationVersion;
    },
    getColorScheme(state) {
      return state.colorScheme;
    },
    getProjectUuid(state) {
      return state.projectUuid;
    },
    getIsUserAuthtorized(state) {
      return state.userAlias?.length > 0;
    }
  }
};
